import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '@/helpers/cn';
import { mergeRefs } from '@/helpers/mergeRefs';
import { forwardRef, useRef } from 'react';
import { usePreventScroll } from 'react-aria';
const SubMenu = forwardRef(({ id, className, children, role, ariaHidden, onClose, noOverflow, style }, forwardedRef) => {
    const ref = useRef(null);
    usePreventScroll({ isDisabled: !noOverflow });
    const handleKeyUp = (event) => {
        if (event.key === 'Escape') {
            onClose?.();
        }
    };
    return (_jsx("div", { ref: mergeRefs(ref, forwardedRef), id: id, "data-testid": id, className: cn('ease-in-out" absolute top-full right-0 z-50 w-full flex-col bg-white px-1 pt-1 pb-1.5 shadow-md transition-all duration-200 md:top-[calc(99%_+_3px)] md:max-w-[293px]', className), role: role, "aria-hidden": ariaHidden, onKeyUp: handleKeyUp, tabIndex: -1, style: style, onBlurCapture: (event) => {
            // Ensure submenu is closed when focus moves outside of it
            if (!ref.current?.contains(event.relatedTarget)) {
                onClose?.(event.relatedTarget);
            }
        }, children: children }));
});
export default SubMenu;
